module.exports = __webpack_public_path__ + "static/badge-google-play-0f73d00601821a6f14b067389897ad69.svg";